import {Component, Input} from '@angular/core';
import {EVENT_CALENDAR_ROUTE} from "src/app/app-routing.module";
import {Router} from "@angular/router";
import { Message } from '@model';

@Component({
    selector: 'app-error-state',
    templateUrl: './error-state.component.html',
    styleUrls: ['./error-state.component.scss'],
    standalone: false
})
export class ErrorStateComponent {
  constructor(private router: Router) {
  }

  onGoToEventCalendar() {
    this.router.navigate([EVENT_CALENDAR_ROUTE]);
  }
}
